var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newMark row align-center",class:_vm.text ? 'text' : ''},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }